import { render, staticRenderFns } from "./AssistingAccounting.vue?vue&type=template&id=4bf6cee7"
import script from "./AssistingAccounting.vue?vue&type=script&lang=js"
export * from "./AssistingAccounting.vue?vue&type=script&lang=js"
import style0 from "./AssistingAccounting.vue?vue&type=style&index=0&id=4bf6cee7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports